<div *ngIf="$vm | async as vm" class="mt-6 pb-6">
  <dg-information-notice
    *ngFor="let s of vm.selectionSummary"
    [title]="s.title"
    [description]="s.description"
    icon="circle-check"
    cta="Change"
    (changeCTA)="
      resetFormState(s.formName, vm.selectionSummary, vm.claim, freeTextSearch)
    "
  >
  </dg-information-notice>

  <ng-container *ngIf="showCustomLayout; else standardLayout">
    <form [formGroup]="vm.form">
      <div class="custom-question-box" *ngIf="!showInWarrantyNotice">
        <ng-container
          *ngIf="(vm.formData?.groups?.[0]?.radios?.radioGroup ?? []).length > 1"
        >
          <h3>What caused the fault?</h3>
          <div class="radio-group">
            <label
              *ngFor="let option of vm.formData.groups[0].radios.radioGroup"
            >
              <input
                type="radio"
                formControlName="claimType"
                [value]="option.value"
                (change)="onSelectionChanged()"
                (focus)="
                  isKeyboardNavigation &&
                    autoSelectValue('claimType', option.value, vm.form)
                "
              />
              {{ option.text }}
            </label>
          </div>
        </ng-container>

        <div
          *ngIf="showUsabilityQuestion"
          class="usability-question"
          [ngClass]="{ 'no-margin-top': claimTypeAutoComplete }"
        >
          <h3>Can you still use the appliance?</h3>
          <div class="radio-group">
            <label *ngFor="let option of usabilityOptions">
              <input
                type="radio"
                formControlName="ApplianceUseable"
                [value]="option.value"
                (change)="onSelectionChanged()"
                #usabilityQuestion
                (focus)="
                  isKeyboardNavigation &&
                    autoSelectValue('ApplianceUseable', option.value, vm.form)
                "
              />
              {{ option.text }}
            </label>
          </div>
        </div>

        <div *ngIf="showError" class="error-message">
          <dgx-components-icon name="circle-exclamation"></dgx-components-icon>
          <p class="body">Select an option to continue.</p>
        </div>

        <div class="button-container" [class.show-error]="showError">
          <dgx-components-button
            type="submit"
            variant="primary"
            iconName="arrow-right"
            class="continue-button"
            (clicked)="onContinueClick(vm.form, vm.selectionSummary, vm.claim)"
          >
            Confirm
          </dgx-components-button>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-template #standardLayout>
    <dg-information-notice
      *ngIf="vm.formData"
      [title]="vm.formData.header"
      [description]="vm.formData.description"
      [ngClass]="{
        fts:
          vm.formData.freeTextSearch &&
          !vm.freeTextSearchState?.fallBackToOldSelect
      }"
      [showReallyHelpSection]="standardNetworkFaultCapture"
    >
      <!-- Free text search approach -->
      <form
        *ngIf="
          vm.formData.freeTextSearch &&
          !vm.freeTextSearchState?.fallBackToOldSelect
        "
        [formGroup]="faultDataSearchForm"
        class="free-text-search-form xs-12"
        [ngClass]="{
          hasDescription:
            vm.freeTextSearchState.results.length > 0 || showFreeTextSearchError
        }"
        (submit)="searchFaults()"
      >
        <ul>
          <li>
            <p class="typog-body">
              Please enter a keyword most related to the fault you are
              experiencing.
            </p>
          </li>
          <li>
            <p class="typog-body">
              If your appliance has multiple faults, select the main one.
            </p>
          </li>
          <li>
            <p class="typog-body">
              You can always give more details in the
              <strong>comments box</strong> later on.
            </p>
          </li>
        </ul>

        <section class="search">
          <dgx-form-row>
            <dgx-form-field
              label="Fault selection"
              formControlName="search"
              [errorsHidden]="true"
              [optionalHidden]="true"
            >
              <dgx-form-text-input
                name="fault-search"
                placeholder="Enter the fault"
              >
              </dgx-form-text-input>

              <dg-loader *ngIf="vm.freeTextSearchState.running"></dg-loader>

              <dgx-components-icon
                *ngIf="showFreeTextSearchError"
                name="circle-exclamation"
                class="error-icon"
              >
              </dgx-components-icon>
            </dgx-form-field>
            <small
              *ngIf="
                showFreeTextSearchError || vm.freeTextSearchState.results.length
              "
              class="free-text-search-hint typog-caption"
              [ngClass]="{
                error: showFreeTextSearchError
              }"
            >
              <ng-container
                *ngIf="
                  vm.freeTextSearchState.run &&
                  vm.freeTextSearchState.results.length &&
                  !showFreeTextSearchError
                "
              >
                {{ vm.freeTextSearchState.results.length }} search
                {{
                  vm.freeTextSearchState.results.length === 1
                    ? 'result'
                    : 'results'
                }}
              </ng-container>

              <ng-container *ngIf="showFreeTextSearchError">
                {{
                  faultDataSearchForm.get('search').errors?.required
                    ? 'Enter fault'
                    : "We don't recognise that fault. Check and try again."
                }}
              </ng-container>
            </small>
          </dgx-form-row>

          <dgx-components-button
            iconName="search"
            iconAlign="right"
            type="submit"
            [ngClass]="{
              formRun:
                vm.freeTextSearchState.run &&
                (vm.freeTextSearchState.results.length ||
                  showFreeTextSearchError)
            }"
          >
            Search
          </dgx-components-button>
        </section>

        <section
          *ngIf="vm.freeTextSearchState.results.length"
          class="results"
          #optionContainer
        >
          <section
            class="option"
            *ngFor="let result of vm.freeTextSearchState.results"
          >
            <p>
              {{ result.faultId_descr }} -
              <span>{{ result.problemId_descr }}</span>
            </p>

            <dgx-components-button
              [fill]="true"
              variant="secondary"
              (clicked)="selectResult(result, vm.selectionSummary)"
            >
              Select
            </dgx-components-button>
          </section>
        </section>
      </form>
    </dg-information-notice>

    <dg-information-notice
      *ngIf="vm.showContinueCTA"
      [title]="
        standardNetworkFaultCapture
          ? undefined
          : vm?.selectionSummary?.length === 1
          ? 'Please check your selection and make any changes if needed.'
          : 'Please check your selections and make any changes if needed.'
      "
      [description]="description"
      [showPleaseCheckAnswers]="standardNetworkFaultCapture"
    >
    </dg-information-notice>

    <!-- General fault breakdown -->

    <ng-container *ngIf="standardNetworkFaultCapture">
      <ng-container *ngIf="!selectedFault">
        <section class="standard-fault-title">
          <h5>
            {{
              selectedCategory
                ? selectedCategory.FaultCategoryName
                : "What's the issue?"
            }}
          </h5>

          <button
            *ngIf="selectedCategory"
            (click)="
              selectedCategory = undefined;
              resetFormState(
                'faultArea',
                vm.selectionSummary,
                vm.claim,
                freeTextSearch
              )
            "
          >
            <dgx-components-icon name="arrow-left"></dgx-components-icon>
            <span> Back to all fault types </span>
          </button>
        </section>

        <section class="tiles">
          <ng-container *ngIf="!selectedCategory">
            <button
              class="tile"
              *ngFor="let tile of faultOptionsList"
              [title]="tile.FaultCategoryName"
              (click)="setCategory(tile)"
            >
              <dgx-components-icon
                *ngIf="
                  genericFaultListIconMap[tile.FaultCategoryName | lowercase]
                "
                class="section-icon"
                size="lg"
                [name]="
                  genericFaultListIconMap[tile.FaultCategoryName | lowercase]
                    .icon
                "
                [style.--icon-colour]="
                  genericFaultListIconMap[tile.FaultCategoryName | lowercase]
                    .colour
                "
              >
              </dgx-components-icon>
              <span>
                {{ tile.FaultCategoryName }}
              </span>
              <dgx-components-icon name="arrow-right"> </dgx-components-icon>
            </button>
          </ng-container>

          <ng-container *ngIf="selectedCategory">
            <button
              class="tile"
              *ngFor="let tile of selectedCategory.PossibleAnswers"
              [title]="tile.FaultLabel"
              (click)="setFault(tile, vm.selectionSummary)"
            >
              <span>
                {{ tile.FaultLabel }}
              </span>
            </button>
          </ng-container>
        </section>
      </ng-container>
    </ng-container>

    <!-- Standard tile selection -->
    <form
      *ngIf="
        vm.form &&
        !standardNetworkFaultCapture &&
        (!vm.formData.freeTextSearch ||
          vm.freeTextSearchState?.fallBackToOldSelect)
      "
      [formGroup]="vm.form"
      (change)="formTypeChange(vm.form, vm.selectionSummary, vm.claim)"
    >
      <section
        *ngIf="vm.freeTextSearchState?.fallBackToOldSelect && showFallbackAlert"
        class="fallback-error"
      >
        <dgx-components-icon name="circle-exclamation"></dgx-components-icon>
        <span>Sorry, something went wrong. Please pick a fault instead.</span>
      </section>
      <div [@fadeInAnimation]>
        <dg-fb-radiobutton
          *ngFor="let group of vm.formData.groups"
          [elementsPerPage]="group.radios?.elementsPerPage"
          [group]="vm.form"
          [align]="'justify--left'"
          [classes]="'dg-radios ' + group.radios?.classes"
          [idPrefix]="group.radios?.control"
          [control]="group.radios?.control"
          [items]="group.radios?.radioGroup"
          [validators]="group.radios?.validators"
        >
        </dg-fb-radiobutton>
      </div>
    </form>
  </ng-template>

  <claims-claim-type-selection-notice
    *ngIf="showInWarrantyNotice || showplanInWaitPeriodNotice || isIWEnabled"
    [claim]="claim"
    [showInWarrantyNotice]="showInWarrantyNotice"
    [showplanInWaitPeriodNotice]="showplanInWaitPeriodNotice"
    [isIWEnabled]="isIWEnabled"
    (continueClicked)="continue(vm?.form)"
    (routeToPlanDetails)="routeToPlanDetails()"
    (routeToDashBoard)="routeToDashBoard()"
  ></claims-claim-type-selection-notice>

  <smart-fix-chat-container
    [claim]="vm.claim"
    *ngIf="vm.claim && showSmartFixChatBot && mode === 'filter'"
    (closedChatNotification)="onChangeSmartFixChat($event)"
  ></smart-fix-chat-container>

  <smart-fix-boiler-chat-container
    [claim]="vm.claim"
    *ngIf="vm.claim && showSmartFixChatBot && mode === 'boiler'"
    (closedChatNotification)="onChangeSmartFixChat($event)"
  ></smart-fix-boiler-chat-container>

  <div
    *ngIf="
      showPreChatBanner &&
        !isGasLeak(vm.selectionSummary) &&
        vm.showContinueCTA;
      else currentCTA
    "
  >
    <div class="block">
      <div *ngIf="smartFixChatState === 'open'" data-testid="showPreChatBanner">
        <smart-fix-pre-chat-banner-boiler
          *ngIf="isProduct(claim, 'boiler'); else washing"
          (openChatbot)="triggerSmartFixChatBot('boiler')"
          (continueBooking)="continueBooking()"
          (bannerVisible)="preChatVisible()"
        ></smart-fix-pre-chat-banner-boiler>
        <ng-template #washing>
          <smart-fix-pre-chat-banner
            class="flex"
            [appliance]="productType"
            (openChatbot)="triggerSmartFixChatBot('filter')"
            (continueBooking)="continueBooking()"
            (bannerVisible)="preChatVisible()"
          ></smart-fix-pre-chat-banner>
        </ng-template>
      </div>

      <div
        *ngIf="vm.showContinueCTA && smartFixChatState === 'closed'"
        class="flex mt-6 pb-6"
      >
        <dgx-components-button
          type="submit"
          variant="primary"
          iconName="arrow-right"
          (click)="continueBookingAfterSmartFixChat()"
          data-automation="'ConfirmAD'"
        >
          {{ cta }}
        </dgx-components-button>
      </div>
    </div>
  </div>

  <ng-template #currentCTA>
    <div *ngIf="vm.showContinueCTA" class="flex mt-6 pb-6">
      <dgx-components-button
        type="submit"
        variant="primary"
        iconName="arrow-right"
        (click)="cs.submitClaim(true)"
        data-automation="'ConfirmAD'"
      >
        {{ cta }}
      </dgx-components-button>
    </div>
  </ng-template>
</div>
